import styled from '@emotion/styled';
import { AlignT, ImageParagraphT, ImageWidthT } from 'types/shared/core/Post';
import Config from 'config/Config';
import interfaceBridge from 'utils/interfaceBridge';
import DownloadIcon from 'assets/icons/download.svg';

type PostContentImagePropsT = {
  paragraph: ImageParagraphT;
};

const StyledImageParagraph = styled('div')<{
  width: ImageWidthT;
  imageAlign: AlignT;
}>`
  padding: 0px ${(props) => (props.width === '100' ? 0 : 16)}px;

  & > div > img {
    display: inline-block;
    width: 100%;
    background-color: rgba(128, 128, 128, 0.5);

    /* width: ${(props) => `${props.width}%`}; */
  }

  & > div {
    position: relative;
    width: ${(props) => `${props.width}%`};

    margin: ${(props) =>
      props.imageAlign === 'left'
        ? '0 auto 0 0'
        : props.imageAlign === 'center'
        ? '0 auto'
        : '0 0 0 auto'};

    overflow: hidden;
    line-height: 0;
  }

  & > div > div.download-button {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 44px;
    height: 44px;
    border-top-left-radius: 8px;
    background: rgba(0, 0, 0, 0.3);
    background-image: url(${DownloadIcon}); /* Update the path to your image */
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.5;
  }
`;

function PostContentImage({ paragraph }: PostContentImagePropsT) {
  const handleClick = () => {
    const baseUrl = `${Config.fileServerBaseUrl}${Config.contentImagePathPrefix}`;

    const url = `${baseUrl}${paragraph.path}`;
    console.log('attachment url=', url);

    interfaceBridge.downloadFile(
      url,
      paragraph.fileName || 'noImageName',
      'image',
    );
  };

  const baseUrl = `${Config.fileServerBaseUrl}${Config.smallContentImagePathPrefix}`;

  return (
    <StyledImageParagraph imageAlign={paragraph.align} width={paragraph.width}>
      <div>
        <img src={`${baseUrl}${paragraph.path}`} width="100%" />
        <div className="download-button" onClick={handleClick} />
      </div>
    </StyledImageParagraph>
  );
}
export default PostContentImage;
